import TransactionsController from './TransactionsController';
import { apiRequest } from '../utils/useAPIRequest';
import { appStore, bulkSmsStore, walletStore } from '../stores';
import constant from '../utils/constant';

const getSingleMessage = async id => {
	const { status, data, errorMessage } = await apiRequest({
		url: `/bulk-sms/bulk-sms/${id}`,
		method: 'get',
	});
	if (status === constant.Success) {
		return { status: constant.Success };
	}
	return { errorMessage, status };
};

const getAllMessages = async () => {
	const { status, data, errorMessage } = await apiRequest({
		url: '/bulk-sms/messages',
		method: 'get',
	});

	if (status === constant.Success) {
		bulkSmsStore.setAllMessages(data.bulkSms);
		return { status: constant.Success };
	}

	return { errorMessage, status };
};

const getAllProspects = async () => {
	const { status, data, errorMessage } = await apiRequest({
		url: '/bulk-sms/prospect',
		method: 'get',
	});

	if (status === constant.Success) {
		bulkSmsStore.setAllProspects(data.prospects);
		return { status: constant.Success };
	}

	return { errorMessage, status };
};

const sendBulkSms = async payload => {
	const { status, data, errorMessage } = await apiRequest({
		url: '/bulk-sms/send',
		method: 'post',
		payload,
	});

	if (status === constant.Success) {
		getAllMessages();
		getAllProspects();
		return { status: constant.Success, data };
	}
	return { errorMessage, status };
};

const saveSmsDraft = async payload => {
	const { status, data, errorMessage } = await apiRequest({
		url: '/bulk-sms/save-draft',
		method: 'post',
		payload,
	});
	if (status === constant.Success) {
		getAllMessages();
		getAllProspects();
		return { status: constant.Success, data };
	}
	return { errorMessage, status };
};

const scheduleSms = async payload => {
	const { status, data, errorMessage } = await apiRequest({
		url: '/bulk-sms/schedule-sms',
		method: 'post',
		payload,
	});


	if (status === constant.Success) {
		getAllMessages();
		getAllProspects();
		return { status: constant.Success, data };
	}
	return { errorMessage, status };
};

const sendDraftSms = async (id, payload) => {
	const { status, data, errorMessage } = await apiRequest({
		url: `/bulk-sms/send-draft/${id}`,
		method: 'post',
		payload,
	});


	if (status === constant.Success) {
		getAllMessages();
		getAllProspects();
		return { status: constant.Success, data };
	}
	return { errorMessage, status };
};

const editSms = async (messageId, payload) => {
	const { status, data, errorMessage } = await apiRequest({
		url: `/bulk-sms/edit-draft/${messageId}`,
		method: 'patch',
		payload,
	});

	if (status === constant.Success) {
		getAllMessages();
		getAllProspects();
		return { status: constant.Success, data };
	}
	return { errorMessage, status };
};

const overrideScheduleSend = async id => {
	const { status, data, errorMessage } = await apiRequest({
		url: `/bulk-sms/send-scheduled/${id}`,
		method: 'get',
	});
	if (status === constant.Success) {
		getAllMessages();
		getAllProspects();
		return { status: constant.Success };
	}
	return { errorMessage, status };
};

export default {
	getSingleMessage,
	getAllMessages,
	sendBulkSms,
	saveSmsDraft,
	scheduleSms,
	sendDraftSms,
	getAllProspects,
	editSms,
	overrideScheduleSend,
};
